/// <reference types="@angular/localize" />

/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */
(window as any).global = window;
(window as any).process = { env: { DEBUG: undefined } };
(window as any).module = { exports: {} };

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component'; // Import your root component
import { environment } from '@env/environment';

import { Amplify } from 'aws-amplify';

import awsConfig from './aws-exports';
if (environment.production) {
    enableProdMode();
}
Amplify.configure(awsConfig);
import { appConfig } from 'app/app.config';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
